module.exports = __webpack_public_path__ + "img/Dantam Hair 33.18d29e3d.jpg";